import React from 'react'
import axios from 'axios'
import './rotasModule.css'
import { formatDate, formatDateTimeInBrasilia, getNormalizedRoute } from './rotaHelpers'
import { ensurePdfResponse, extractBlobErrorMessage, openPdfBlob } from '../../utils/openPdfBlob'

export default class RotasView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            list: null,
            loaded: false,
            ficha: { obsCoord: '' }
        }
    }

    componentDidMount() {
        const id = this.props.match.params.id
        axios(`/api/rota/rotaView/${id}`)
            .then((resp) => this.setState({ list: resp.data, loaded: true, ficha: { obsCoord: resp.data.obsCoord || '' } }))
            .catch((error) => alert(error.response?.data || 'Erro ao carregar rota.'))
    }

    updateField = (event) => {
        this.setState({ ficha: { ...this.state.ficha, [event.target.name]: event.target.value } })
    }

    aprova = async (event) => {
        if (!this.isAberta()) return

        try {
            await axios.post('/api/rota/aprova2', {
                aprovadas: event.target.name === 'aprova' ? [this.state.list._id] : [],
                reprovadas: event.target.name === 'reprova' ? [this.state.list._id] : [],
                obsCoord: this.state.ficha.obsCoord
            })
            alert('Rotas atualizadas.')
            window.location = '/rotas'
        } catch (error) {
            alert(error.response?.data || 'Erro ao decidir rota.')
        }
    }

    isDecidida() { return ['aprovada', 'reprovada'].includes(this.state.list?.situacao) }
    isAberta() { return this.state.list?.situacao === 'aberta' }

    abrirPdfIndividual = async () => {
        if (!this.state.list?._id) return

        const pdfWindow = window.open('', '_blank', 'noopener,noreferrer')

        try {
            const response = await axios.get(`/api/rota/relatorio/pdf/${this.state.list._id}`, {
                responseType: 'blob'
            })
            const pdfData = await ensurePdfResponse(response, 'Não foi possível gerar o PDF da rota.')

            openPdfBlob({
                data: pdfData,
                filename: `rota-${this.state.list._id}.pdf`,
                targetWindow: pdfWindow
            })
        } catch (error) {
            if (pdfWindow && !pdfWindow.closed) {
                pdfWindow.close()
            }

            const message = error instanceof Error && error.message
                ? error.message
                : await extractBlobErrorMessage(error, 'Erro ao gerar PDF da rota.')

            alert(message || 'Erro ao gerar PDF da rota.')
        }
    }

    renderDecisionAudit() {
        const normalized = getNormalizedRoute(this.state.list)
        if (!this.isDecidida()) return null

        return (
            <div className="rota-audit-box mt-4">
                <p className="rota-eyebrow text-white-50 mb-1">Auditoria</p>
                <h3 className="mb-3">Decisão registrada</h3>
                <div><strong>Decisão:</strong> {normalized.decision.tipoDecisao === 'reprovada' ? 'Reprovada' : 'Aprovada'}</div>
                <div><strong>Responsável:</strong> {normalized.decision.usuarioDecisaoNome || 'Não informado'}</div>
                <div><strong>Hash:</strong> {normalized.decision.hashDecisao || 'Não informado'}</div>
                {normalized.decision.dataDecisao && <div><strong>Data:</strong> {formatDateTimeInBrasilia(normalized.decision.dataDecisao)}</div>}
                {normalized.decision.obsCoord && <div className="mt-2"><strong>Observações:</strong> {normalized.decision.obsCoord}</div>}
            </div>
        )
    }

    renderItems(items, title, alternative = false) {
        return (
            <div className="rota-surface mb-4">
                <p className="rota-eyebrow mb-1">{alternative ? 'Alternativas' : 'Principais'}</p>
                <h2 className="rota-section-title mb-3">{title}</h2>
                <div className="row">
                    {items.length === 0 && <div className="col-12"><p className="rota-muted mb-0">Nenhum item informado.</p></div>}
                    {items.map((item) => (
                        <div className="col-12 mb-3" key={`${item.tipoItem}-${item.indice}`}>
                            <div className={`rota-item-card ${alternative ? 'alternative' : ''}`}>
                                <div className="row">
                                    <div className="col-md-8"><strong>{item.estabelecimento || 'Estabelecimento não informado'}</strong></div>
                                    <div className="col-md-4 text-md-right rota-muted">{formatDate(item.data)}</div>
                                    <div className="col-md-6 mt-3"><span className="rota-label">Endereço</span><div>{item.endereco || 'Não informado'}</div></div>
                                    <div className="col-md-3 mt-3"><span className="rota-label">Município</span><div>{item.municipio || 'Não informado'}</div></div>
                                    <div className="col-md-3 mt-3"><span className="rota-label">Motivo</span><div>{item.motivo || 'Não informado'}</div></div>
                                    <div className="col-md-3 mt-3"><span className="rota-label">Diária</span><div>{item.diaria || 'Não informado'}</div></div>
                                    <div className="col-md-3 mt-3"><span className="rota-label">Tipo de diária</span><div>{item.tipoDiaria || 'Não informado'}</div></div>
                                    <div className="col-md-3 mt-3"><span className="rota-label">Execução</span><div>{item.realizada === null ? 'Pendente' : item.realizada ? 'Realizada' : 'Não realizada'}</div></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    renderDecisionActions() {
        if (!this.isAberta()) return null
        return (
            <div className="rota-surface">
                <p className="rota-eyebrow mb-1">Coordenação</p>
                <h3 className="rota-section-title mb-3">Registrar decisão</h3>
                <label className="rota-label">Observações da coordenação</label>
                <textarea rows="4" className="form-control rota-input mb-4" name="obsCoord" value={this.state.ficha.obsCoord} onChange={this.updateField} />
                <div className="d-flex flex-wrap justify-content-end" style={{ gap: '1rem' }}>
                    <button className="btn rota-secondary-button" name="aprova" onClick={this.aprova}>Aprovar</button>
                    <button className="btn rota-danger-button" name="reprova" onClick={this.aprova}>Reprovar</button>
                </div>
            </div>
        )
    }

    render() {
        if (!this.state.loaded || !this.state.list) return <div className="container rota-page">Carregando...</div>
        const normalized = getNormalizedRoute(this.state.list)
        const status = normalized.situacao || 'aberta'

        return (
            <div className="container rota-page">
                <div className="rota-hero">
                    <div className="d-flex flex-wrap justify-content-between align-items-start" style={{ gap: '1rem' }}>
                        <div>
                            <p className="rota-eyebrow mb-1">Módulo de Rotas</p>
                            <h1 className="rota-title mb-2">Visualização da rota</h1>
                            <p className="rota-subtitle mb-0">Fiscal {normalized.fiscal || 'Não informado'} · Estado {normalized.estado || 'Não informado'}</p>
                        </div>
                        <div className="d-flex flex-wrap align-items-center" style={{ gap: '0.75rem' }}>
                            <button className="btn rota-secondary-button" onClick={this.abrirPdfIndividual}>Gerar PDF</button>
                            <span className={`rota-status-pill ${status}`}>{status.toUpperCase()}</span>
                        </div>
                    </div>
                </div>
                {this.renderItems(normalized.itensPrincipais, 'Rotas principais')}
                {this.renderItems(normalized.itensAlternativos, 'Rotas alternativas', true)}
                <div className="rota-surface mb-4">
                    <p className="rota-eyebrow mb-1">Observações</p>
                    <h3 className="rota-section-title mb-3">Contexto da solicitação</h3>
                    <div><span className="rota-label">Fiscal</span><div>{normalized.obsFiscal || 'Sem observações do fiscal.'}</div></div>
                </div>
                {this.renderDecisionAudit()}
                {this.renderDecisionActions()}
            </div>
        )
    }
}
